export default __webpack_public_path__ + "static/media/prev_button.d7a3b8fb.svg";